module.exports = __webpack_public_path__ + "static/media/norway_grants.eb5a3106.png";